import { KpiSection } from '../../../../data-models/company-financials.data-model';
import { IField } from '../../../../data-models/field2.data-model';
import { uuid } from '../../../../util/uuid';
import {
  ConsolidatedTemplateVersion,
  CustomKpiTemplateFormValues,
  CustomTemplateSectionType,
  IConsolidatedTemplate,
  IConsolidatedTemplateSection,
  SectionTypeLabel,
  TemplateSectionFormValues,
} from '../../../../schemas/kpi-template.schema';

export function formToTemplateDataModel(
  form: CustomKpiTemplateFormValues,
  kpiConfigMap: Map<number, IField<unknown>>
): Partial<IConsolidatedTemplate> {
  return {
    id: form.id,
    name: form.name,
    uuid: form.uuid,
    meta: { version: ConsolidatedTemplateVersion },
    sections: form.sections
      .filter((s) => s.kpis.length > 0)
      .map((section, index) => ({
        id: section.id,
        ...(form.id != null && { templateId: form.id }),
        type: section.type,
        name: SectionTypeLabel[section.type],
        meta: {
          section: getSectionKpiSection(section),
          sortOrder: index,
          kpis: section.kpis
            .map((id) => kpiConfigMap.get(id))
            .filter((kpi): kpi is IField<unknown> => kpi != null)
            .map((kpi, i) => ({ ...kpi, sortOrder: i })),
        },
      })) as IConsolidatedTemplateSection[],
  };
}

export function templateDataModelToForm(template: IConsolidatedTemplate): CustomKpiTemplateFormValues {
  return {
    id: template.id,
    name: template.name,
    uuid: template.uuid,
    sections: (template.sections ?? [])
      .sort((a, b) => a.meta.sortOrder - b.meta.sortOrder)
      .map(sectionDataModelToFormValues),
  };
}

function getSectionKpiSection(section: TemplateSectionFormValues): KpiSection {
  if (section.type === CustomTemplateSectionType.quantitative) {
    return section.sectionType;
  }
  return KpiSection.actual;
}

function sectionDataModelToFormValues(section: IConsolidatedTemplateSection): TemplateSectionFormValues {
  return {
    _key: uuid(),
    id: section.id,
    type: section.type,
    sectionType: section.meta.section,
    kpis: [...section.meta.kpis].sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0)).map((kpi) => kpi.id),
  };
}
